export const createRandomId = (type: string, delimiter: string = '-'): string => {
  return [type, Math.random().toString(36).substring(2, 11)].join(delimiter)
}
